// src/tiles/ReceiptsList.jsx
import React from 'react';
import { Stack, Link, Typography } from '@mui/material';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import { useReceiptsVisibility } from '../../context/ReceiptsVisibilityContext';

export default function ReceiptsList({ receipts = [], linkable = true }) {
  const { show } = useReceiptsVisibility?.() || { show: false };

  // Respect global receipts toggle + keep original empty guard
  if (!show || !receipts?.length) return null;

  return (
    <Stack
      spacing={1}
      sx={{
        mt: 1,
        px: 1,
        py: 1,
        mb: 1,                 // space under the grey block
        borderLeft: '2px solid',
        borderColor: 'divider',
        bgcolor: 'action.hover',
        borderRadius: 0.5
      }}
    >
      {receipts.slice(0, 2).map((r, i) => {
        const hasUrl = !!r.url;
        const hasTs = !!r.timestamp;
        const clickable = linkable && (hasUrl || hasTs);

        // Preserve your current linking behavior:
        // - If URL present, use it as-is.
        // - Else if only timestamp present, use an in-page anchor with #t=...
        const href = hasUrl ? r.url : (hasTs ? `#t=${encodeURIComponent(r.timestamp)}` : undefined);

        const QuoteBlock = (
          <Stack key={i} direction="row" spacing={1} alignItems="flex-start">
            {clickable && (
              <OndemandVideoIcon fontSize="small" sx={{ mt: '2px', flex: '0 0 auto' }} />
            )}
            <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
              “{r.quote}”
            </Typography>
          </Stack>
        );

        return clickable ? (
          <Link
            key={i}
            href={href}
            target={hasUrl ? "_blank" : undefined}
            rel={hasUrl ? "noopener" : undefined}
            underline="hover"
            sx={{ display: 'block' }}
          >
            {QuoteBlock}
          </Link>
        ) : (
          <React.Fragment key={i}>{QuoteBlock}</React.Fragment>
        );
      })}
    </Stack>
  );
}
